import { render, staticRenderFns } from "./ManageNewsListItem.vue?vue&type=template&id=7d7a5b15&scoped=true"
import script from "./ManageNewsListItem.vue?vue&type=script&lang=js"
export * from "./ManageNewsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7a5b15",
  null
  
)

export default component.exports